jQuery(document).ready(function($){
    
    // March 18, points
    if ($('[data-points-price]').length && window.Shopify){

        var slCurrencyRate = window.Shopify.currency.rate;

        $('[data-points-price]').each(function(){
            var productPrice = $(this).attr('data-points-price');
            var productCurrency = $(this).attr('data-currency-symbol');

            if (productCurrency !== '$'){
               
                productPrice = productPrice / slCurrencyRate;
                var points = productPrice * 10;
                points = points.toFixed(2);
                $(this).html(points).addClass('updated-points');

            }
        });
    }


    
    
    var socialLinks = '';
    socialLinks+= '<div class="communication-container">';
    socialLinks+= '<ul class="communication">';
    socialLinks+= '<li><a href="tel:+18888822041"><img src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/menu-call.png?v=1656055619" class="img-fluid"/></a>';
    socialLinks+= '<li><a href="https://m.me/shinyleafusa" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/menu-messenger.png?v=1656055619" class="img-fluid"/></a>';
    socialLinks+= '<li><a href="mailto:support@shinyleaf.com"><img src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/menu-email.png?v=1656055620" class="img-fluid"/></a>';
    socialLinks+= '</ul>';
    socialLinks+= '</div>';
    jQuery('#shopify-section-header #ariaHamburger').prepend(socialLinks);

  
    jQuery('.mobile-search-item').prependTo('#shopify-section-header ul.main-menu');


    


    jQuery('#shopify-section-header [href="/blogs/features/relaxing-with-essential-oils"]').after('<a style="margin-top:10px;display:block;" href="https://www.shinyleaf.com/pages/meet-the-ingredients" title="Meet the Ingredients"><img class="img-fluid" alt="Meet the Ingredients" title="Meet the Ingredients" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Drop_Down_Menu.jpg?v=1645702977"/></a>');

    // Conditioners
    // jQuery('#shopify-section-header [href="/products/castor-oil-conditioner"]').before('<a class="dropdown-conditioners" href="https://www.shinyleaf.com/collections/conditioners" title="Conditioners">Conditioners</a>');


    // jQuery('.mobile-search-item').append('<li class="child"><a style="margin-top:10px;display:block;" href="https://www.shinyleaf.com/pages/meet-the-ingredients" title="Meet the Ingredients"><img class="img-fluid" alt="Meet the Ingredients" title="Meet the Ingredients" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Drop_Down_Menu.jpg?v=1645702977"/></a></li>');


    // Advance Menu + Collections
    if ($('.kids-4').length){
        $('.kids-4').addClass('advance-menu-parent');
        $('.kids-4 .main-menu-dropdown').closest('ul').append('<li class="custom-menu-placement parent"></li>');
        // $('.kids-4 .custom-menu-placement').append('<a href="https://www.shinyleaf.com/pages/hair-quiz" title="Hair Quiz"><img class="img-fluid" alt="Hair Quiz" title="Hair Quiz" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Hair_Quiz_1.jpg?v=1656045540"/></a>');
        $('.kids-4 .custom-menu-placement').append('<a href="https://www.shinyleaf.com/pages/meet-the-ingredients" title="Meet the Ingredients"><img class="img-fluid" alt="Meet the Ingredients" title="Meet the Ingredients" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Meet_The_Ingredients_1.jpg?v=1656045540"/></a>');
        

         if ($(this).width() < 768){

            // var mobilePlacements = '';
            // mobilePlacements+='<li class="child mobile-special-placement">';
            // mobilePlacements+='<div class="row">';
            // mobilePlacements+='<div class="col-6"><a href="https://www.shinyleaf.com/pages/hair-quiz" title="Hair Quiz"><img class="img-fluid" alt="Hair Quiz" title="Hair Quiz" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Hair_Quiz_1.jpg?v=1656045540"/></a></div>';
            // mobilePlacements+='<div class="col-6"><a href="https://www.shinyleaf.com/pages/meet-the-ingredients" title="Meet the Ingredients"><img class="img-fluid" alt="Meet the Ingredients" title="Meet the Ingredients" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/Meet_The_Ingredients_1.jpg?v=1656045540"/></a></div>';
            // mobilePlacements+='</div>';
            // mobilePlacements+='</li>';
            // jQuery('.nav-link[title="Contact"]').parent('li').after(mobilePlacements);


            // Links Updates
            var linksToMove = ['Best Sellers','Promotions','Guidebook','Store Locator'];

            $.each(linksToMove,function(index,linkToMove){
                $('.mobile-search-item').before($('#ariaHamburger > li > .nav-link[title="'+linkToMove+'"]').parent('li'));
            });

            var linksToRemove = ['Hair Quiz'];

            $.each(linksToRemove,function(index,linkToMove){
                $('#ariaHamburger > li > .nav-link[title="'+linkToMove+'"]').parent('li').hide()
            });
            

            var shopAllElement = $('#ariaHamburger > li > .nav-link[title="Shop All"]');
            var shopAllLinks = shopAllElement.siblings('.main-menu-dropdown').find('ul').first();
            
            shopAllLinks.each(function(){
                $('.communication-container').after($(this));
                // $('.show-joy-rewards').after($(this));
              
            });

            shopAllElement.remove();
            // $('.mobile-special-placement').after('<li class="child">' + jQuery('.nav-link[title="Login"]').parent('li').html() + '</li>').remove();

            // $('.advance-menu-parent > .main-menu-dropdown > ul > li').each(function(){
            //     $('#ariaHamburger').prepend($(this).html());
            // });
        }
    
    }

    // $(window).on('load',function(){
    //   jQuery(document).on('.show-joy-rewards','click',function(){
    //       $('#Avada-Joy_FloatingButtonTrigger').click();
    //   });
    // });

  

    if ($('.nav-link[title="Hair Care"]').length){

        var hairCareElement = $('.nav-link[title="Hair Care"]');
        hairCareElement.addClass('with-sub-collections');
        

        var hairCareParent = hairCareElement.parent('li');

        var html = '<ul class="sub-collection-container">';
        html+='<li><a href="/collections/hair-care-products" class="nav-link" title="All Hair Care" aria-expanded="false">All Hair Care</a></li>';
        html+='<li><a href="/collections/shampoos" class="nav-link" title="Shampoos" aria-expanded="false">Shampoos</a></li>';
        html+='<li><a href="/collections/conditioners" class="nav-link" title="Conditioners" aria-expanded="false">Conditioners</a></li>';
        html+='<li><a href="/collections/hair-care-sets" class="nav-link" title="Sets" aria-expanded="false">Sets</a></li>';
        html+='</ul>';
        hairCareParent.append(html);

    }


    if ($('.nav-link[title="Skin Care"]').length){
        var skinCareElement = $('.nav-link[title="Skin Care"]');
        skinCareElement.addClass('with-sub-collections');

        var skinCareParent = skinCareElement.parent('li');


        var html = '<ul class="sub-collection-container">';
        html+='<li><a href="/collections/skin-care-products" class="nav-link" title="Skin Hair Care" aria-expanded="false">All Skin Care</a></li>';
        html+='<li><a href="/collections/face-serums" class="nav-link" title="Serums" aria-expanded="false">Serums</a></li>';
        // html+='<li><a href="/collections/natural-oils" class="nav-link" title="Oils" aria-expanded="false">Oils</a></li>';
        html+='</ul>';
        skinCareParent.append(html);
    }

    if ($('.nav-link[title="Wellness"]').length){
        var skinCareElement = $('.nav-link[title="Wellness"]');
        skinCareElement.addClass('with-sub-collections-x');

        var skinCareParent = skinCareElement.parent('li');


        var html = '<ul class="sub-collection-container-x" style="display:block">';
        html+='<li><a href="https://www.shinyleaf.com/collections/bariatric-supplements" class="nav-link" title="Bariatric Supplements" aria-expanded="false">Bariatric Supplements</a></li>';
        html+='<li><a href="https://www.shinyleaf.com/collections/bariatric-shampoo-and-conditioners" class="nav-link" title="Bariatric Shampoo and Conditioners" aria-expanded="false">Bariatric Shampoo and Conditioners</a></li>';
        html+='</ul>';
        skinCareParent.append(html);
    }

    // For Desktop, update menu
    // if (jQuery('li.grandparent.kids-7').length && $('.showDesktop').length){
    //     var grandparent = jQuery('li.grandparent.kids-7');
    //     grandparent.removeClass('kids-7').addClass('kids-5 desktop-updates');


    //     var conditionerMenu = grandparent.find('.parent').eq(1);
    //     var conditionerMenuContent = conditionerMenu.html();

    //     var shampooMenu = grandparent.find('.parent').eq(0);
    //     conditionerMenu.remove();
    //     shampooMenu.append(conditionerMenuContent);


    //     var wellnessMenu = grandparent.find('.parent').eq(3);
    //     var wellnessMenuContent = wellnessMenu.html();

    //     var accessMenu = grandparent.find('.parent').eq(4);
    //     wellnessMenu.remove();
    //     accessMenu.append(wellnessMenuContent);
    // }



    if ($('#ResetSuccess').length){
        $('div#CustomerLoginForm').hide();
        $('div#RecoverPasswordForm').show();
    }

    /*
    * Google Rating
    */

    var googleRatingBadgeStatus = false;
    var googleRatingBadgeInterval = setInterval(function(){
        console.log('googleRatingBadgeInterval - Running');
        if (jQuery('#___ratingbadge_0').length && !googleRatingBadgeStatus){
            jQuery('#___ratingbadge_0').appendTo(jQuery('.footer-logos-container.footer-partners-logo-container')); 
            jQuery('#___ratingbadge_0').css('position','relative');
            googleRatingBadgeStatus = true;
            clearInterval(googleRatingBadgeInterval);
            console.log('googleRatingBadgeInterval - Stopping');
        }
    },1000);
    
    
    


    // Account Error - Registration Inactive (2020-11-13)
    if ( jQuery("#CustomerRegisterForm").length && jQuery(".errors").length){
        var isContains = $('.errors').text().indexOf('please click the link included to verify your email address.') > -1;

        if (isContains){
            jQuery("#CustomerRegisterForm .errors").addClass('errors-positive');
        }
    }

    
    /*
    * Referal Dashboard Redirect
    */

    if ($('.account-container').length){
        if (localStorage.getItem('affiliate_redirect')){
            if (localStorage.getItem('affiliate_redirect') == 'yes'){
                window.location.href = 'https://www.shinyleaf.com/pages/affiliate-dashboard';
                localStorage.setItem('affiliate_redirect','no');
            }
        }
    }else{
        localStorage.setItem('affiliate_redirect','no');
        if ($('input[name="return_url"]').length){
            if ($('input[name="return_url"]').val() == '/pages/simple-affiliate'){
                localStorage.setItem('affiliate_redirect','yes');
            }
        }
    }

    /*
    * JudgeMe Reviews Extension
    * Created At: 2019-10-15
    * Updated At: 2020-12-09
    */

    // $(window).load(function(){
    $(window).on('load',function(){

        if ($('#judgeme_product_reviews').length && window.location.hash){

            console.warn('Hash: ' + window.location.hash);

            if (window.location.hash == '#section-reviews'){
                if (window.location.search != ''){
                    switch (window.location.search) {
                        case '?channel=ebay':
                        case '?channel=other':
                        case '?channel=rakuten':
                        case '?channel=etsy':
                        case '?channel=newegg':
                        case '?channel=gs':
                            console.warn('Location Review Channel : ' + window.location.search);

                            // Do Something Amazing
                            var jdgmFormEmail = $('.jdgm-form__email-fieldset');
                            jdgmFormEmail.after('<div class="jdgm-email-clone">' + jdgmFormEmail.html() + '</div');

                            jdgmFormEmail.find('input').attr('name', 'reviewer_email_old');
                            jdgmFormEmail.find('input').attr('type', 'email_old');

                            $('.jdgm-email-clone').find('input').val('eilonarad@gmail.com');
                            $('.jdgm-email-clone').hide();

                        break;
                    }
                }else{
                    console.warn('Location Review Channel : N/A');
                }
            }
            
        }
    });


    console.log('shinyleaf-theme.js is running!');

    /*
    * Footer Navigation 
    */
    $(document).on('click','.footer-navigation h2',function(){
        if ($(window).width() < 620){
            if ($(this).hasClass('active')){
                $(this).removeClass('active');
            }else{
                $('.footer-navigation h2').removeClass('active');
                $(this).addClass('active');
            }
        }else{
            $('.footer-navigation h2').removeClass('active');
        }
    });


    // var homeSlidersURL = 'https://app.shinyleafcosmetics.com/wp-json/acf/v3/options/shinyleaf-promotions/slide_version_2';
    // console.log(homeSlidersURL);
    // console.log("HOME PAGE SLIDERS: " + homeSlidersURL);
    var homepageLayersSliderContainer = $('.homepage-layers-slider-container');

    if (homepageLayersSliderContainer.length) {
        var homepageLayersSlider = $('.homepage-layers-slider');
        homepageLayersSlider.css('opacity', 0);
        homepageLayersSlider.slick({
            autoplay: true,
            autoplaySpeed: 7500,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
        homepageLayersSlider.css('opacity', 1);

        // $.get(homeSlidersURL, function (response) {

        //     var response = response.acf;
            
        //     console.log('Home Page Layers Slider');
        //     console.log(response);


        //     var sliders = response.slide_version_2;
        //     console.log('Home Page Layers Slider - Slides');
        //     console.log(sliders);

            

        //     $.each(sliders, function (index, slider) {

        //         if (slider.meta.start_date != ''){

        //             console.log('Home Page Layers Slide');
        //             console.log(slider);

        //             var startDate = slider.meta.start_date + ' UTC-0400';
        //             var endDate = slider.meta.end_date + ' UTC-0400';
        //             var currentDate = new Date();
        //             var currentMs = Date.parse(currentDate);
        //             var startMs = Date.parse(startDate);
        //             var endMs = Date.parse(endDate);

        //             console.log('-------------');
        //             console.log('Slider: ' + index);
        //             console.log('Current Date: ' + currentDate);
        //             console.log('Start Date: ' + startDate);
        //             console.log('End Date: ' + endDate);
        //             console.log('-------------');

        //             if (currentMs >= startMs && currentMs <= endMs) {


        //                 var slide = '';
        //                 slide += '<div class="slide layer-slider-' + index + '">';
        //                 slide += '<div class="row">';

        //                 slide += '<div class="col-md-8">';
        //                 slide += '<a href="' + slider.meta.link + '">';



        //                 // Desktop Layers
        //                 slide += '<div class="homepage-layer homepage-layer-desktop">';


        //                 $.each(slider.desktop_layers, function (index, layer) {

        //                     if (layer.start_date == '' && layer.end_date == '') {

        //                         console.log('empty dates');
        //                         console.log(layer);
        //                         slide += '<div class="layer">';
        //                         slide += '<img class="img-fluid layer-image" src="' + layer.image.url.replace('app.shinyleafcosmetics.com', 'd1uklzixz2ffop.cloudfront.net') + '">';
        //                         slide += '</div>';

        //                     } else {

        //                         console.log('with dates');
        //                         var startDate = layer.start_date + ' UTC-0400';
        //                         var endDate = layer.end_date + ' UTC-0400';
        //                         var currentDate = new Date();
        //                         var currentMs = Date.parse(currentDate);
        //                         var startMs = Date.parse(startDate);
        //                         var endMs = Date.parse(endDate);

        //                         console.log('-------------');
        //                         console.log('Desktop Layer: ' + index);
        //                         console.log('Current Date: ' + currentDate);
        //                         console.log('Start Date: ' + startDate);
        //                         console.log('End Date: ' + endDate);
        //                         console.log('-------------');

        //                         if (currentMs >= startMs && currentMs <= endMs) {

        //                             console.log(layer);
        //                             slide += '<div class="layer">';
        //                             slide += '<img class="img-fluid layer-image" src="' + layer.image.replace('app.shinyleafcosmetics.com', 'd1uklzixz2ffop.cloudfront.net') + '">';
        //                             slide += '</div>';

        //                         }
        //                     }

        //                 });


        //                 slide += '</div>';
        //                 slide += '</a>';
        //                 slide += '</div>';

        //                 slide += '<div class="col-md-4">';
        //                 slide += '<div class="slider-content-container">';
        //                 slide += '<div class="content">';
        //                 slide += slider.content;
        //                 slide += '</div>';
        //                 slide += '<div class="action">';
        //                 slide += '<a title="' + slider.meta.button_label + '" href="' + slider.meta.link + '">' + slider.meta.button_label + '</a>';


        //                 slide += '<style>';
        //                 slide += '.layer-slider-' + index + ' .slider-content-container a{';
        //                 slide += 'background-color:' + slider.meta.button_background_color + ';';
        //                 slide += 'color:' + slider.meta.button_color + ';';
        //                 slide += 'border:1px solid ' + slider.meta.button_background_color + ';';
        //                 slide += '}';
        //                 slide += '.layer-slider-' + index + ' .slider-content-container a:hover{';
        //                 slide += 'color:' + slider.meta.button_background_hover_color + ';';
        //                 slide += 'background-color:white;';
        //                 slide += '}';
        //                 slide += '</style>';


        //                 slide += '</div>';
        //                 slide += '</div>';
        //                 slide += '</div>';



        //                 slide += '</div>';
        //                 slide += '</div>';

        //                 console.log('APpending Slide');
        //                 console.log(slide);

        //                 homepageLayersSlider.prepend(slide);
        //             }
        //         }
                
        //     });

        //     homepageLayersSliderContainer.find('.homepage-layers-loader').hide();
        //     homepageLayersSlider.slick({
        //         autoplay: true,
        //         autoplaySpeed: 7500,
        //         responsive: [
        //             {
        //                 breakpoint: 600,
        //                 settings: {
        //                     arrows: false,
        //                     dots: true
        //                 }
        //             }
        //             // You can unslick at a given breakpoint now by adding:
        //             // settings: "unslick"
        //             // instead of a settings object
        //         ]
        //     });
        //     homepageLayersSlider.fadeTo(2000, 1);

        // });
    }


    /*
    * Mobile App Banner for Mobile Web Users
    * Created At: 2019-09-04
    * Updated At: 2019-09-04
    */
    var mobileAppTopBanner = {
        bannerURL: 'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/mobile-web-mobile-app-banner.jpg',
        platforms: {
            android: {
                title: 'Get it on Google Play',
                storeURL: 'https://play.google.com/store/apps/details?id=shinyleaf.mobile',
                iconURL: 'https://cdn.shopify.com/s/files/1/0009/7684/6907/t/5/assets/shinyleaf-android-icon.png',
            },
            ios: {
                title: 'Available on App Store',
                storeURL: 'https://apps.apple.com/us/app/shiny-leaf/id1460759908',
                iconURL: 'https://cdn.shopify.com/s/files/1/0009/7684/6907/t/5/assets/shinyleaf-ios-icon.png',
            }
        },
        currentPlatform: null,
        status: false,
        html: '',
        impressions: 0,
        impressionsRequirement: 1,
        localStorageKey: 'mobile-app-top-banner-xx',
        closeButtonUrl: 'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/mobile-web-mobile-app-close.png',
        checkImpression: function () {

            this.impressions = 0;
            var impressionLocationStorage = window.localStorage.getItem(this.localStorageKey);

            if (impressionLocationStorage == null) {
                this.impressions = 1;
            } else {
                this.impressions = impressionLocationStorage;
                this.impressions = parseInt(this.impressions) + 1;
            }
            window.localStorage.setItem(this.localStorageKey, this.impressions);
            return this.impressions;
        },
        operatingSystem: function () {

            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";

        },
        registerEvents: function () {

            jQuery('body').on('click', '.mobile-app-top-banner-close-container', function () {
                jQuery('.mobile-app-top-banner-container').slideUp(600);
            });

            jQuery('body').on('click', '.mobile-app-top-banner-container a', function () {
                ga('send', 'event', 'Button', 'Click', 'Mobile App Top Banner');
            });

        },
        init: function () {


            if (this.checkImpression() <= this.impressionsRequirement) {

                switch (this.operatingSystem()) {

                    case 'Android':
                        this.status = true;
                        this.currentPlatform = this.platforms.android;
                        break;

                    case 'iOS':
                        this.status = true;
                        this.currentPlatform = this.platforms.ios;
                        break;
                }


                if (this.status === true) {

                    var html = '';
                    html += '<div class="mobile-app-top-banner-container">';

                    html += '<div class="mobile-app-top-banner-close-container">';
                    html += '<img  class="img-fluid" title="Close - ' + this.currentPlatform.title + '" alt="Close - ' + this.currentPlatform.title + '" src="' + this.closeButtonUrl + '">';
                    html += '</div>';

                    html += '<div class="mobile-app-top-image-container">';
                    html += '<a title="' + this.currentPlatform.title + '" href="' + this.currentPlatform.storeURL + '">';
                    html += '<img class="img-fluid" title="' + this.currentPlatform.title + '" alt="' + this.currentPlatform.title + '" src="' + this.bannerURL + '">';
                    html += '</a>';
                    html += '</div>';

                    html += '</div>'

                    jQuery('body').prepend(html);

                    this.registerEvents();

                }
            }

        }
    }

    // mobileAppTopBanner.init();

    /*
    * End - Mobile App Banner for Mobile Web Users
    */

    $(document).on('click','.redirect-to-mobile-app-store',function(e){
        e.preventDefault();
        
        var currentPlatform;

        switch (mobileAppTopBanner.operatingSystem()) {

            case 'Android':
                window.location.href = mobileAppTopBanner.platforms.android.storeURL;
                break;

            case 'iOS':
                window.location.href =  mobileAppTopBanner.platforms.ios.storeURL;
                break;
            
            default:
                window.location.href = 'https://www.shinyleaf.com/pages/rewards#section-rewards-mobile';
        }
    });

    /*
    * Parameter Checker
    */
    // var urlParams = new URLSearchParams(window.location.search);
    // if (urlParams.get('ar') !== null){
        
    //     console.warn(urlParams.get('ar'));
    //     var output = '';
    //     output += '<div class="white-popup ar-popup">';
    //     output += '<div class="white-popup-content">';
    //     output += '<p class="white-popup-description">You are now unsubscribed to our reminder list.</p>';
    //     output += '</div>';
    //     output += '</div>';

    //     $.magnificPopup.open({
    //         items: {
    //             src: output, // can be a HTML string, jQuery object, or CSS selector
    //             type: 'inline'
    //         }
    //     });

    // }else{
    //     console.warn('AR: No action required!');
    // }
    
    /*
    * rechargeSubscriptionsTable
    */

    var rechargeSubscriptionsTable = $('.rc_table__container.table-responsive');
    if (rechargeSubscriptionsTable.length){
        var text = '';
        text = '<div class="swap-text-container">If you want to change your order, chat us at <a target="_blank" href="https://m.me/shinyleafusa">https://m.me/shinyleafusa</a>.<br>You may also email us at <a href="mailto:support@shinyleaf.com">support@shinyleaf.com</a>.</div>';
        rechargeSubscriptionsTable.after(text);
    }

    /*
     * HTML Scheduler
     */
    if ($('html-scheduler').length) {
        $('html-scheduler').each(function () {

            var data = {
                version: $(this).attr('data-version'),
                startDate: $(this).attr('data-start-date'),
                endDate: $(this).attr('data-end-date'),
                content: $(this).attr('data-content')
            }

            var startDate = data.startDate + ' UTC-0400';
            var endDate = data.endDate + ' UTC-0400';
            var currentDate = new Date();
            var currentMs = Date.parse(currentDate);
            var startMs = Date.parse(startDate);
            var endMs = Date.parse(endDate);

            if (currentMs >= startMs && currentMs <= endMs) {
                console.warn('html-scheduler is on');
                $(this).show();
            } else {
                console.warn('html-scheduler is off');
            }

        });
    }


    // Promotion Tab Function
    $(document).ready(function () {
        // $('.promotions-item').each(function () {
        //     if ($(this).hasClass('previous')) {
        //         $(this).appendTo('#previous_promotion');
        //         $('.promotion-tab').removeClass('hide');
        //     }
        // });

        $('.promotions-item').each(function () {

            var data = {
                startDate: $(this).attr('data-start'),
                endDate: $(this).attr('data-end'),
            }

            var startDate = data.startDate + ' UTC-0400';
            var endDate = data.endDate + ' UTC-0400';
            var currentDate = new Date();
            var currentMs = Date.parse(currentDate);
            var startMs = Date.parse(startDate);
            var endMs = Date.parse(endDate);

            if (currentMs >= startMs && currentMs <= endMs) {
                // console.warn('html-scheduler is on');
                // $(this).show();
            } else {
                if (currentMs <= endMs) {
                    $(this).remove();
                    $('.promotion-tab').removeClass('hide');
                }else{
                    $(this).appendTo('#previous_promotion');
                    $('.promotion-tab').removeClass('hide');
                }
            }

            // if ($(this).hasClass('previous')) {
            //     $(this).appendTo('#previous_promotion');
            //     $('.promotion-tab').removeClass('hide');
            // }
        });


        $('.tab-selector ul.selector-wrap li').each(function () {
            $(this).find('a').click(function () {
                var tab_url = $(this).attr('href');
                $('.promotion-tab-content').removeClass('active');
                $('.promotion-tab-content').addClass('hide');
                $(tab_url).addClass('active');
                $(tab_url).removeClass('hide');
                $('.tab-selector ul.selector-wrap li a').removeClass('active');
                $(this).addClass('active');
            });
        });
    });

    $('#header-promotions-icon').on('click',function(){
        $('.header-promotion-placeholder').click();
        console.warn('#header-promotions-icon was clicked');
    });



    var shippingProtectionVariantID = 33515590811780;
    var shippingProtection = localStorage.getItem('shipping_protection');
    var shippingProtectStatus = false;
  
    document.addEventListener('rebuy:smartcart.show', (event) => {
      /*
      * Shipping Protection
      * 2020-04-23
      */
      
      if (!shippingProtection){
          localStorage.setItem('shipping_protection', 'yes');
          shippingProtectStatus = true;
      }else{
          
          if (shippingProtection == 'yes'){
              shippingProtectStatus = true;
          }else{
              shippingProtectStatus = false;
          }
  
      }
      $('.shipping-protection-checkbox').prop('checked', shippingProtectStatus);
      checkShippingProtection();
      
      const smartcart = event.detail.smartcart;
    
      console.log('rebuy:smartcart.ready: smartcart', smartcart);
    });


    document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
      const smartcart = event.detail.smartcart;
      const item = event.detail.item;
      console.log("rebuy:smartcart.line-item-removed: smartcart", smartcart, item);
      checkShippingProtection();
    });

    document.addEventListener("rebuy:smartcart.item-switch-to-subscription", (event) => {
       const smartcart = event.detail.smartcart;
       const item = event.detail.item;
    
         console.log("rebuy:smartcart.item-switch-to-subscription, smartcart", smartcart, item);
        checkShippingProtection();
     });
  
      document.addEventListener("rebuy:smartcart.item-switch-to-one-time", (event) => {
     const smartcart = event.detail.smartcart;
     const item = event.detail.item;
  
     console.log("rebuy:smartcart.item-switch-to-one-time, smartcart", smartcart, item);
        checkShippingProtection();
   });

  
     document.addEventListener('rebuy:cart.change', (event) => { 
         console.log('rebuy:cart.change event', event.detail); 
         // checkShippingProtection();
    });

    $(document).on('change','.rebuy-cart__flyout-item-subscription select',function(){
      if (shippingProtectStatus){
        var shippingProtectionSellingData = {
            id: shippingProtectionVariantID,
            quantity: 0,
            selling_plan: null
        };
        $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: shippingProtectionSellingData,
              dataType: 'json',
              success: function (response) {
                checkShippingProtection();
              }
        });
      }
    });

    function checkShippingProtection(){
      
          // Remove all selling plan
          var shippingProtectionSellingData = {
              id: shippingProtectionVariantID,
              quantity: 0,
              selling_plan: null
          };
          // $.ajax({
          //     type: "POST",
          //     url: "/cart/change.js",
          //     data: shippingProtectionSellingData,
          //     dataType: 'json',
          //     success: function (response) {

          
                  var shippingProtectionPayload = {
                      updates: {
                          33515590811780: 0
                      }
                  };
                  $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: shippingProtectionPayload,
                    dataType: 'json',
                    success: function (response) {
          
                        if (shippingProtectStatus){
                      
                          console.warn('SP Update.js',response);
            
                          console.warn('For Removals - SP Enabled');
                          $('.shipping-protection-container').addClass('shipping-protection-on');
                
                          // Add Shipping Status to Cart
                          var sellingPlansAvailable = [];
                          
                
                          // Month x Selling Plan ID
                          var sellingPlans = [];
                          sellingPlans["1"] = 2912878818;
                          sellingPlans["2"] = 2912911586;
                          sellingPlans["3"] = 2912944354;
                          sellingPlans["6"] = 2912977122;
                          sellingPlans["12"] = 2913009890;
                
                          
                          // Selling Plan ID x Month
                          var sellingPlansReference = [];
                          $.each(sellingPlans,function(index,sellingPlan){
                              sellingPlansReference[sellingPlan] = index;
                          });
                
                          if (response.items.length){
                              $.each(response.items,function(index,item){
                                  //console.log(item);
                                  if (item.selling_plan_allocation){
                                      var sellingPlan  = item.selling_plan_allocation.selling_plan;
                                      console.log(sellingPlan);
                
                                      var month = sellingPlansReference[sellingPlan.id];
                                      if (!sellingPlansAvailable.includes(month)){
                                          sellingPlansAvailable.push(month);
                                      }
                                  }
                              });
                          }
                
                          
                
                          var shippingProtectionData = {
                              id: shippingProtectionVariantID,
                              quantity: 1
                          };
                
                          console.warn("For Removals - sellingPlansAvailable",sellingPlansAvailable);
                          console.warn("For Removals - shippingProtectionData",shippingProtectionData);
                
                          
                          if (sellingPlansAvailable.length){
                
                              console.log('sellingPlansAvailable', sellingPlansAvailable);
                              var sellingPlanMonth = Math.min(...sellingPlansAvailable);
                
                              var shippingProtectionSellingPlans = [];
                              shippingProtectionSellingPlans["1"] = 2928410850;
                              shippingProtectionSellingPlans["2"] = 2928443618;
                              shippingProtectionSellingPlans["3"] = 2928476386;
                              shippingProtectionSellingPlans["6"] = 2928509154;
                              shippingProtectionSellingPlans["12"] = 2928541922;
                
                              var sellingPlanID = shippingProtectionSellingPlans[sellingPlanMonth];
                
                              console.log('sellingPlanMonth',sellingPlanMonth);
                              console.log('sellingPlanID',sellingPlanID);
                              shippingProtectionData.selling_plan = sellingPlanID;
                
                          }
                
                          $.ajax({
                              type: "POST",
                              url: "/cart/add.js",
                              data: shippingProtectionData,
                              dataType: 'json',
                              success: function (response) {
                                  console.warn('For Removals - SP Add.js',response);
                
                              }
                
                          });
                       }else{
                          console.warn('For Removals - SP Disabled');
                          $('.shipping-protection-container').removeClass('shipping-protection-on');
                      }
                    }
          
          
                });

        //   }

        // });        
    }

    /*
     * Shipping Protection Event
     * 2020-04-23
     */
    $(document).on('click', '.shipping-protection-info', function() {

        var imageSource = $(this).attr('data-image'); //'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/shinyleaf-shipping-protection.png?v=1588137929';

        if ($(window).width() < 600) {
            imageSource = $(this).attr('data-image-mobile'); //'https://cdn.shopify.com/s/files/1/0009/7684/6907/files/shinyleaf-shipping-protection-mobile.png?v=1588137929';
        }

        var outputHTML = '';
        outputHTML += '<div class="white-popup white-popup-shipping-protection">';
        outputHTML += '<img class="img-fluid" alt="Shipping Protection" title="Shipping Protection" src="' + imageSource + '">';
        outputHTML += '</div>';

        $.magnificPopup.open({
            items: {
                src: outputHTML, // can be a HTML string, jQuery object, or CSS selector
                type: 'inline'
            }
        });

    });

    $(document).on('click', '.shipping-protection-toggle', function() {
        $('.shipping-protection-checkbox').click();
    });

    $(document).on('change', '.shipping-protection-checkbox', function() {

        if ($(this).prop('checked')) {
            localStorage.setItem('shipping_protection', 'yes');
            $('.shipping-protection-container').addClass('shipping-protection-on');
            shippingProtectStatus = true;

        } else {
            localStorage.setItem('shipping_protection', 'no');
            $('.shipping-protection-container').removeClass('shipping-protection-on');
            shippingProtectStatus = false;
        }
      
        checkShippingProtection();
        

    });

});